import { TextField } from '@mui/material';
import { Dispatch, Fragment, SetStateAction, useState } from 'react';
import { DemographicCategory } from '../../../interfaces/EOAInterface';
import CustomButton from '../../reusable/CustomButton';
import AddedItems from './AddedItems';

interface DemographicValuesAliasProps {
  label: string;
  category: DemographicCategory;
  setCategory: Dispatch<SetStateAction<DemographicCategory>>;
}

function DemographicValuesAlias({ label, category, setCategory }: DemographicValuesAliasProps) {
  const [newAlias, setNewAlias] = useState<Record<string, string>>({});

  const demographicValuesNames = category.demographic_values.map((value) => value.district_name);

  const handleChangeAlias = (e: { target: { name: string; value: string } }) => {
    const { name, value } = e.target;
    setNewAlias((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddNewAlias = (districtName: string) => {
    const alias = newAlias[districtName].trim();

    setCategory((prev) => {
      const demographic_values = [...prev.demographic_values];
      const demograhic_value = demographic_values.find((item) => item.district_name === districtName);

      if (demograhic_value) {
        const existingAliases = demograhic_value.aliases || [];
        if (!existingAliases.includes(alias)) {
          demograhic_value.aliases = [...existingAliases, alias];
        }
      }

      return { ...prev, demographic_values: demographic_values };
    });

    setNewAlias((prev) => ({ ...prev, [districtName]: '' }));
  };

  const handleDeleteAlias = (districtName: string, aliasToRemove: string) => {
    setCategory((prev) => {
      const demographic_values = [...prev.demographic_values];
      const demographic_value = demographic_values.find((item) => item.district_name === districtName);

      if (demographic_value) {
        demographic_value.aliases = demographic_value.aliases.filter((alias) => alias !== aliasToRemove);
      }

      return { ...prev, demographic_values: demographic_values };
    });
  };

  return (
    <>
      <h4>{`${label} Aliases`}</h4>
      {demographicValuesNames.map((name) => (
        <Fragment key={name}>
          <TextField
            placeholder={`${name} Alias`}
            variant="outlined"
            name={name}
            value={newAlias[name] || ''}
            onChange={handleChangeAlias}
          />
          <CustomButton
            variant="primary"
            size="medium"
            disabled={!newAlias[name]?.trim()}
            buttonText="Add Alias"
            buttonAction={() => handleAddNewAlias(name)}
          />
          <AddedItems
            addedItems={category.demographic_values.find((value) => value.district_name === name)?.aliases || []}
            isDeletable={() => true}
            handleDelete={(alias) => handleDeleteAlias(name, alias)}
          />
        </Fragment>
      ))}
    </>
  );
}

export default DemographicValuesAlias;
